import * as Yup from 'yup';
export const initialRelationValues = {
    description: '',
    enumId: '',
};
export const relationSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=relation.js.map